import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Dependente } from '../model/Dependente';
import { Serie } from '../model/Serie';

@Injectable({
  providedIn: 'root'
})
export class CarrinhoService {

  private urlApi = environment.rootUrlApi + 'carrinho';

  constructor(private http: HttpClient) { }

  public voucher(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/voucher', dados);
  }

  public listaDependentes(guid: number): Observable<Dependente[]> {
    return this.http.get<Dependente[]>(this.urlApi + '/listaDependentes/' + guid);
  }

  public resumoCarrinho(guid: number): Observable<Dependente[]> {
    return this.http.get<Dependente[]>(this.urlApi + '/getResumoCarrinho/' + guid);
  }

  public addDependentes(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/addDependente', dados);
  }

  public addCarrinho(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/addCarrinho', dados);
  }

  public addEnderecoEntrega(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/addEnderecoEntrega', dados);
  }

  public listaAno(id_escola: number): Observable<Serie[]> {
    return this.http.get<Serie[]>(this.urlApi + '/listaSeries/' + id_escola);
  }

  public listaMateriais(guid: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/listaMateriais', guid);
  }

  public deleteDependente(id: number): Observable<any> {
    return this.http.delete<any>(this.urlApi + '/deleteDependente/' + id);
  }

  public validaItinerario(guid: string): Observable<any> {
    return this.http.get<any>(this.urlApi + '/getValidaItinerario/' + guid);
  }

  public getItinerario(): Observable<any> {
    return this.http.get<any>(this.urlApi + '/getItinerarios');
  }
}
